import { render, staticRenderFns } from "./LawsRegulations.vue?vue&type=template&id=663605b5&scoped=true&"
import script from "./LawsRegulations.vue?vue&type=script&lang=js&"
export * from "./LawsRegulations.vue?vue&type=script&lang=js&"
import style0 from "./LawsRegulations.vue?vue&type=style&index=0&id=663605b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663605b5",
  null
  
)

export default component.exports